import { Facebook, Instagram, Linkedin, Theater } from "lucide-react";
import { Link } from "react-router-dom";
import { GlobalFooter } from "./GlobalFooter";

export const Footer = () => {
  const seoPages = [
    { path: "/kabaret-na-event-firmowy", label: "Kabaret na event firmowy" },
    { path: "/kabaret-na-impreze-integracyjna", label: "Kabaret na imprezę integracyjną" },
    { path: "/kabaret-na-wesele", label: "Kabaret na wesele" },
    { path: "/kabaret-na-konferencje", label: "Kabaret na konferencję" },
    { path: "/kabaret-na-jubileusz", label: "Kabaret na jubileusz firmy" },
    { path: "/kabaret-na-wigilie-firmowa", label: "Kabaret na wigilię firmową" },
    { path: "/stand-up-na-event", label: "Stand-up na event" },
    { path: "/kabaret-na-gale", label: "Kabaret na galę" },
    { path: "/komik-na-event", label: "Komik na event" },
    { path: "/kabaret-na-bankiet", label: "Kabaret na bankiet" },
    { path: "/kabaret-na-zamowienie", label: "Kabaret na zamówienie" },
    { path: "/kabaret-na-bal-firmowy", label: "Kabaret na bal firmowy" },
    { path: "/atrakcje-na-event-firmowy", label: "Atrakcje na event firmowy" },
    { path: "/kabaret-na-piknik-firmowy", label: "Kabaret na piknik firmowy" },
    { path: "/kabaret-na-sylwestra", label: "Kabaret na sylwestra" },
    { path: "/kabaret-na-urodziny-firmy", label: "Kabaret na urodziny firmy" },
    { path: "/kabaret-na-spotkanie-firmowe", label: "Kabaret na spotkanie firmowe" },
    { path: "/kabaret-na-otwarcie-firmy", label: "Kabaret na otwarcie firmy" },
    { path: "/kabaret-na-targi", label: "Kabaret na targi" },
    { path: "/prowadzenie-imprez-firmowych", label: "Prowadzenie imprez firmowych" },
    { path: "/kabaret-na-szkolenie", label: "Kabaret na szkolenie" },
    { path: "/kabaret-na-rocznice-firmy", label: "Kabaret na rocznicę firmy" },
  ];

  const cityPages = [
    { path: "/wystep-kabaretowy-warszawa", label: "Warszawa" },
    { path: "/wystep-kabaretowy-krakow", label: "Kraków" },
    { path: "/wystep-kabaretowy-wroclaw", label: "Wrocław" },
    { path: "/wystep-kabaretowy-poznan", label: "Poznań" },
    { path: "/wystep-kabaretowy-gdansk", label: "Gdańsk" },
    { path: "/wystep-kabaretowy-katowice", label: "Katowice" },
    { path: "/wystep-kabaretowy-lodz", label: "Łódź" },
    { path: "/wystep-kabaretowy-szczecin", label: "Szczecin" },
    { path: "/wystep-kabaretowy-lublin", label: "Lublin" },
    { path: "/wystep-kabaretowy-bydgoszcz", label: "Bydgoszcz" },
    { path: "/wystep-kabaretowy-bialystok", label: "Białystok" },
    { path: "/wystep-kabaretowy-rzeszow", label: "Rzeszów" },
    { path: "/wystep-kabaretowy-kielce", label: "Kielce" },
    { path: "/wystep-kabaretowy-opole", label: "Opole" },
    { path: "/wystep-kabaretowy-olsztyn", label: "Olsztyn" },
    { path: "/wystep-kabaretowy-zielona-gora", label: "Zielona Góra" },
    { path: "/wystep-kabaretowy-torun", label: "Toruń" },
    { path: "/wystep-kabaretowy-czestochowa", label: "Częstochowa" },
    { path: "/wystep-kabaretowy-radom", label: "Radom" },
  ];

  return (
    <footer className="bg-primary text-primary-foreground py-16">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-12 text-center md:text-left mb-12">
          <div>
            <div className="flex items-center gap-2 justify-center md:justify-start mb-4">
              <Theater className="w-6 h-6 text-accent" />
              <h3 className="font-montserrat font-bold text-xl">WystepKabaretu.pl</h3>
            </div>
            <p className="text-primary-foreground/60">
              Profesjonalne występy kabaretowe dla firm,
            </p>
            <p className="text-primary-foreground/60">
              które bawią, integrują i pozostają w pamięci.
            </p>
          </div>
          <div>
            <h4 className="font-montserrat font-bold text-lg mb-4">Kontakt</h4>
            <p className="text-primary-foreground/60">
              Email: <a href="mailto:kontakt@wystepkabaretu.pl" className="text-accent hover:underline">kontakt@wystepkabaretu.pl</a>
            </p>
            <p className="text-primary-foreground/60">Tel: +48 533 333 993</p>
          </div>
          <div>
            <h4 className="font-montserrat font-bold text-lg mb-4">Social Media</h4>
            <div className="flex gap-4 justify-center md:justify-start">
              <a href="#" className="text-primary-foreground/60 hover:text-accent transition-colors">
                <Facebook size={24} />
              </a>
              <a href="#" className="text-primary-foreground/60 hover:text-accent transition-colors">
                <Instagram size={24} />
              </a>
              <a href="#" className="text-primary-foreground/60 hover:text-accent transition-colors">
                <Linkedin size={24} />
              </a>
            </div>
          </div>
        </div>

        {/* SEO Pages */}
        <div className="mb-8">
          <h4 className="font-montserrat font-bold text-lg mb-4 text-center">Nasze usługi</h4>
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm">
            {seoPages.map((page) => (
              <Link
                key={page.path}
                to={page.path}
                className="text-primary-foreground/60 hover:text-accent transition-colors"
              >
                {page.label}
              </Link>
            ))}
          </div>
        </div>

        {/* City Pages */}
        <div className="mb-10">
          <h4 className="font-montserrat font-bold text-lg mb-4 text-center">Występy kabaretowe w miastach</h4>
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm">
            {cityPages.map((page) => (
              <Link
                key={page.path}
                to={page.path}
                className="text-primary-foreground/60 hover:text-accent transition-colors"
              >
                {page.label}
              </Link>
            ))}
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-6 mb-8 text-sm">
          <Link to="/rodo" className="text-primary-foreground/60 hover:text-accent transition-colors">Obowiązek informacyjny RODO</Link>
          <Link to="/polityka-prywatnosci" className="text-primary-foreground/60 hover:text-accent transition-colors">Polityka prywatności</Link>
          <Link to="/regulamin" className="text-primary-foreground/60 hover:text-accent transition-colors">Regulamin serwisu</Link>
        </div>
        <GlobalFooter />
      </div>
    </footer>
  );
};
